import { render } from "./diabetes_review.vue?vue&type=template&id=264e3fc4&scoped=true"
import script from "./diabetes_review.vue?vue&type=script&lang=js"
export * from "./diabetes_review.vue?vue&type=script&lang=js"

import "./diabetes_review.vue?vue&type=style&index=0&id=264e3fc4&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264e3fc4"]])

export default __exports__